import { SearchItem } from './module';

export const AuthorSearchModuleId = 'Author' as const;

//Legacy

//V1
export interface AuthorSearchItemDataV1 {
  authorId: string;
  authorName: string;
}

export const AuthorSearchItemVersionV1 = '1' as const;

export interface AuthorSearchItemV1 extends SearchItem<AuthorSearchItemDataV1> {
  version: typeof AuthorSearchItemVersionV1;
  moduleId: typeof AuthorSearchModuleId;
}

export type LegacyAuthorSearchItem = AuthorSearchItemV1;

// Current

export type AuthorSearchItemData = AuthorSearchItemDataV1;

export const AuthorSearchItemVersion = AuthorSearchItemVersionV1;

export type AuthorSearchItem = AuthorSearchItemV1;

export const AuthorItemSpecifier = '@';

export const createAuthorSearchItem = (authorId: string, authorName: string): AuthorSearchItem => ({
  data: {
    authorId,
    authorName,
  },
  id: authorId,
  moduleId: AuthorSearchModuleId,
  version: AuthorSearchItemVersion,
});

export const isLegacyAuthorSearchItem = (item: SearchItem): item is LegacyAuthorSearchItem =>
  item.moduleId === AuthorSearchModuleId;

export const isAuthorSearchItem = (item: SearchItem): item is AuthorSearchItem =>
  item.moduleId === AuthorSearchModuleId && item.version === AuthorSearchItemVersion;
